import { render, staticRenderFns } from "./AlertTag.vue?vue&type=template&id=0afcf92a&"
import script from "./AlertTag.vue?vue&type=script&lang=js&"
export * from "./AlertTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports